// Role permission philosophy:
// - workspace_reader: read everywhere, no mutations.
// - workspace_admin: every permission.
// - platform_admin / platform_access_manager: workspace and member management.
//   There is no dedicated invite resource; workspace_member:invite covers
//   creating, deleting, and updating invites.

import type { RoleKey } from '.';
import type { Permission } from './permissions';
import { PERMISSIONS, Permissions } from './permissions';

const allPermissions: readonly Permission[] = PERMISSIONS;

const readerPerms = allPermissions.filter((p) => p.endsWith(':read'));

const platformAdminPerms: readonly Permission[] = [
  Permissions.workspace.read,
  Permissions.workspace.update,
  Permissions.workspace_member.invite,
  Permissions.workspace_member.delete,
  Permissions.workspace_member.read,
  Permissions.workspace_member.update,
  Permissions.user.read,
  Permissions.user.invite,
  Permissions.user.create,
];
const platformAccessManagerPerms: readonly Permission[] = [
  Permissions.workspace_member.invite,
  Permissions.workspace_member.delete,
  Permissions.workspace_member.read,
  Permissions.workspace_member.update,
  Permissions.workspace.update,
  Permissions.workspace.read,
];

export const rolePermissions: Readonly<
  Record<RoleKey, ReadonlySet<Permission>>
> = {
  workspace_reader: new Set(readerPerms),
  workspace_admin: new Set(allPermissions),
  platform_admin: new Set(platformAdminPerms),
  platform_access_manager: new Set(platformAccessManagerPerms),
};
